// "Rings on Keira’s phone too": a task's reminder also reaches a workspace
// member's phone when the task is with, for or waiting on her in People and
// sits in a suite her login covers (push.WithMember on the server). Whether a
// person is that member is Share with…'s match (routeFor: a live member grant
// whose `from` is one of the person's handles, for the item's suite), so the
// line and the push never disagree. Pure.
import type { GrantResource } from '@/kinds/grant/apply'
import type { PersonResource } from '@/kinds/person/apply'
import { routeFor } from './shareWith'

/** The first names of the linked people whose phones a task's reminder in `ws` also rings on. */
export const ringsOn = (
  people: PersonResource[],
  grants: GrantResource[],
  ws: string | undefined,
  now: number,
): string[] => {
  if (!ws) return []
  const seen = new Set<string>()
  const out: string[] = []
  for (const p of people) {
    if (p.deleted_at) continue
    const r = routeFor(p, grants, { kind: 'Task', id: '', title: '', ws }, now)
    if (r.how !== 'app' || seen.has(r.grant.id)) continue
    seen.add(r.grant.id)
    out.push(p.spec.name.split(/\s+/)[0] || p.spec.name)
  }
  return out
}

/** "Rings on Keira’s phone too", "Rings on Keira’s and Sam’s phones too", or null. */
export const ringsLine = (names: string[]): string | null => {
  if (!names.length) return null
  const owned = names.map((n) => `${n}’s`)
  if (owned.length === 1) return `Rings on ${owned[0]} phone too`
  return `Rings on ${owned.slice(0, -1).join(', ')} and ${owned[owned.length - 1]} phones too`
}
